import { render, staticRenderFns } from "./CompanyListViewItem.vue?vue&type=template&id=cb49bb66&scoped=true&"
import script from "./CompanyListViewItem.vue?vue&type=script&lang=js&"
export * from "./CompanyListViewItem.vue?vue&type=script&lang=js&"
import style0 from "./CompanyListViewItem.vue?vue&type=style&index=0&id=cb49bb66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb49bb66",
  null
  
)

export default component.exports